
<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="800px" transition="dialog-transition">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="primary" v-if='can_operate'>
          <v-icon small left>mdi-flag-checkered</v-icon>
          Gerenciar metas
        </v-btn>
      </template>

      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Metas</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <v-alert type="info" :value="true" v-if="loading_goals">
            Carregando metas...
            <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
          </v-alert>
          <v-form ref='goalsForm' lazy-validation v-if="!loading_goals">
            <v-row class="pa-2 mb-3" justify="center">
              <div v-for="year in years_filters" :key="year">
                <v-btn class="mx-1" small rounded :color="year_filter == year? 'primary' : 'white'" @click="year_filter = year">{{year}}</v-btn>
              </div>
            </v-row>

            <div v-for="(goal, idx) in goals_list_comp" :key="goal.id + '--' + idx">
              <v-row justify="center" align="center">
                <v-text-field @change="submitGoal(idx)" v-model.number="goal.goal" prepend-icon="mdi-search"
                  label="Meta geral do mês" class="mx-2" :rules="[rules.required, rules.notZero]"
                  type='number'></v-text-field>

                <v-dialog ref="dialog" :return-value.sync="goal.begin_date" width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-on="on"
                      :value="new Date(goal.begin_date.substring(0, 10) + 'T12:00:00').toLocaleDateString('pt-BR', { year: 'numeric', month: 'long' })"
                      label="Data" prepend-icon="mdi-calendar" readonly class="mx-2"></v-text-field>
                  </template>
                  <v-date-picker type='month' v-model="goal.begin_date" color="primary" locale="pt-br" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text icon color="success"
                      @click="$refs.dialog[idx].save(goal.begin_date); submitGoal(idx)"><v-icon>mdi-check</v-icon></v-btn>
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-dialog>

                <v-btn text icon color="success" @click="submitNewGoal(idx)"
                  v-if="!goal.id"><v-icon>mdi-content-save-outline</v-icon></v-btn>
                <v-btn text icon color="error" @click="removeGoal(idx)" v-if="!goal.id"><v-icon>mdi-delete</v-icon></v-btn>
              </v-row>
            </div>
            <v-btn text color="primary" @click="addGoal()" rounded><v-icon left>mdi-plus</v-icon>Meta</v-btn>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn color="primary" @click="dialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'SetupGoals',
  data() {
    return {
      key: null,
      dialog: false,
      loading_goals: false,
      adding_goal: false,
      editing_goal: false,
      goals_list: [],
      rules: {
        required: v => !!v || 'Campo é necessário',
        notZero: v => v != 0 || 'Não pode ser zero',
      },

      year_filter: new Date().getFullYear(),

    }
  },
  methods: {
    getGoals() {
      if(this.activeModalityId){
        this.loading_goals = true
        Api.SellerDailyReport.indexGoals({
          year: this.year_filter,
          modality_id: this.activeModalityId
        }).then(r => r.data).then(r => {
          r = r.map(g => {
            let { id, goal, begin_date } = g
            return {
              id, goal, begin_date: begin_date.substring(0, 10)
            }
          })
          this.goals_list = [...r]
        }).finally(() => {
          this.loading_goals = false
        })
      }
    },
    addGoal() {
      this.adding_goal = true
      let last_goal_date = this.goals_list.length ? this.goals_list[this.goals_list.length - 1].begin_date : null
      let new_goal = {
        goal: null,
        begin_date: last_goal_date ? this.$moment(this.year_filter+last_goal_date.substring(4, 10)).add(1, 'month').format('YYYY-MM') : this.$moment().startOf('month').set('year', this.year_filter).format('YYYY-MM')
      }
      this.goals_list.push({ ...new_goal })
    },
    removeGoal(idx) {
      this.goals_list.splice(idx, 1)
    },
    submitNewGoal(idx) {
      if( this.activeModalityId ){
        this.editing_goal = true
        let { id, goal, begin_date } = this.goals_list[idx]
        if (!id) {
          if (this.$refs.goalsForm.validate() && this.validateGoalsDates()) {
            begin_date = begin_date.length > 7 ? begin_date : begin_date + '-01'
            let new_goal = {
              id,
              goal,
              begin_date,
              modality_id: this.activeModalityId
            }
            Api.SellerDailyReport.createGoal(new_goal).then(r => r.data).then(r => {
              let { id, goal, begin_date } = r
              r = {
                id, goal, begin_date: begin_date.substring(0, 10)
              }
              this.goals_list.splice(idx, 1, { ...r })
            }).catch((err) => {
              console.log(err);
            }).finally(() => {
              this.editing_goal = false
              this.$emit("done")
            })
          }
        }
      }
    },
    submitGoal(idx) {
      this.editing_goal = true
      let { id, goal, begin_date } = this.goals_list[idx]
      if (id) {
        begin_date = begin_date.length > 7 ? begin_date : begin_date + '-01'

        let up_goal = {
          id,
          goal,
          begin_date
        }

        Api.SellerDailyReport.updateGoal(up_goal).then(r => r.data).then(r => {
          this.goals_list.splice(idx, 1, { ...r })
        }).catch((err) => {
          console.log(err);
        }).finally(() => {
          this.editing_goal = false
          this.$emit("done")
        })
      }
    },
    submitGoals() {
      if (this.$refs.goalsForm.validate() && this.validateGoalsDates()) {
        let c = confirm('Deseja enviar metas?')
        if (c) {
          this.dialog = false
          this.$emit('done')
        }
      }
    },
    validateGoalsDates() {
      let valid = true
      let dup = this.goals_list.map(gl => gl.begin_date.substring(0, 7)).filter((val, idx, arr) => arr.indexOf(val) != idx)

      valid = dup.length == 0


      if (!valid) {
        dup = dup.filter((val, idx, arr) => arr.indexOf(val) == idx)
        alert(`Os meses: "${dup.map(d => new Date(d).toLocaleDateString('pt-BR', { year: 'numeric', month: 'long' })).join(', ')}" estão duplicados`)
      }

      return valid
    },
  },
  computed: {
    years_filters(){
      let year = (new Date()).getFullYear()
      let years = []
      for (let i = 3; i > 0; i--) {
        years.push(year - i)
      }
      years.push(year)
      for (let i = 1; i <= 3; i++) {
        years.push(year + i)
      }
      return years.sort()
    },
    goals_list_comp(){
      if (this.goals_list.length){
        return this.goals_list.filter(h=> h.begin_date.includes(this.year_filter+'-'))
      }
      return []
    },

    can_operate() {
      if (this.has_roles(['Director', 'Manager', 'SalesExecutive'])) {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    activeModalityId(){
      this.getGoals()
    },
    year_filter(nv,ov) {
      if (nv){
        this.getGoals()
      }
    },
    dialog(nv, ov) {
      if (nv) {
        this.getGoals()
      } else if (nv == false) {
        this.goals_list = []
      }
    }
  },
}
</script>